import { FC } from "react";

const Spinner: FC = () => (
    <div className="flex">
        <Bubble className="mr-2 animate-bubblePurple bg-gradient-to-tl from-primary to-primary/50" />
        <Bubble className="ml-2 animate-bubblePink bg-gradient-to-tr from-primary to-primary/50" />
    </div>
);

const Bubble = ({ className }: { className?: string }) => (
    <div className={`size-6 rounded-full ${className}`} />
);

export default Spinner;
